<div class="progress-bar">
  @if (loading()) {
    <lyceo-skeleton-text [style.width]="width()" />
  } @else {
    <div class="progress" [style.width]="width()"></div>
  }
</div>

@if (showText()) {
  <div class="progress-text ms-2" data-testid="progress-text">
    @if (loading()) {
      <lyceo-skeleton-text />
    } @else {
      {{ progress() }}/{{ total() }}
    }
  </div>
}
